module.exports = __webpack_public_path__ + "img/bar-chart-stacked-dark-02.b9dbc949.jpg";